import { ValidationIcon_default } from "./chunk-N7RSLTZJ.js";
import { InputComponent } from "./chunk-DBD5CSY6.js";
import { DropdownComponent } from "./chunk-RL6PVC4P.js";
import { Spinner_default } from "./chunk-3P5HEDZF.js";
import { Icon_default } from "./chunk-HALE5GZ6.js";
import { use_event_default } from "./chunk-RQOBPP55.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Datepicker/Datepicker.tsx
import { forwardRef, useCallback, useImperativeHandle, useMemo, useRef } from "react";
import clsx from "clsx";
import { format as formatDate, isValid as isValidDate } from "date-fns";
import { DayPicker } from "react-day-picker";
import { jsx, jsxs } from "react/jsx-runtime";
var getNativeInputValueSetter = () => {
  var _a;
  return (_a = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) == null ? void 0 : _a.set;
};
var DATEPICKER_CLASSNAME_MAP = {
  variant: {
    default: "",
    birthday: "pd:datepicker--birthday"
  },
  validation: {
    error: "pd:datepicker--error",
    success: "pd:datepicker--success",
    warning: "pd:datepicker--warning",
    info: "pd:datepicker--info",
    dim: "pd:datepicker--dim"
  }
};
var Datepicker = forwardRef((_a, ref) => {
  var _b = _a,
    {
      variant = "default",
      validation,
      datepickerScreenReaderLabel,
      datepickerConfig: datepickerConfigProp = {},
      value,
      onClick,
      onFocus,
      disabled,
      isLoading,
      className
    } = _b,
    rest = __objRest(_b, ["variant", "validation", "datepickerScreenReaderLabel", "datepickerConfig", "value", "onClick", "onFocus", "disabled", "isLoading", "className"]);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const changeEvent = use_event_default("change", {
    bubbles: true
  });
  const dateValue = useMemo(() => value ? new Date(value) : void 0, [value]);
  const defaultMonth = useMemo(() => isValidDate(dateValue) ? dateValue : /* @__PURE__ */new Date(), [dateValue]);
  useImperativeHandle(ref, () => inputRef.current);
  const datepickerConfig = useMemo(() => {
    if (variant === "birthday") {
      return __spreadProps(__spreadValues({}, datepickerConfigProp), {
        captionLayout: "dropdown"
      });
    }
    return datepickerConfigProp;
  }, [variant, datepickerConfigProp]);
  const handleFocus = useCallback(event => {
    event.preventDefault();
    onFocus == null ? void 0 : onFocus(event);
  }, [onFocus]);
  const handleClick = useCallback(event => {
    event.preventDefault();
    onClick == null ? void 0 : onClick(event);
  }, [onClick]);
  const handleSelectDate = useCallback(selectedDate => {
    var _a2, _b2, _c;
    (_a2 = buttonRef.current) == null ? void 0 : _a2.click();
    const newValue = selectedDate ? formatDate(selectedDate, "yyyy-MM-dd") : "";
    (_b2 = getNativeInputValueSetter()) == null ? void 0 : _b2.call(inputRef.current, newValue);
    (_c = inputRef.current) == null ? void 0 : _c.dispatchEvent(changeEvent);
  }, [changeEvent]);
  return /* @__PURE__ */jsxs(DropdownComponent, {
    className: "pd:datepicker-dropdown",
    children: [/* @__PURE__ */jsxs(InputComponent, {
      validation,
      disabled,
      className: clsx("pd:datepicker", disabled && "pd:datepicker--disabled", isLoading && "pd:datepicker--loading", validation && DATEPICKER_CLASSNAME_MAP.validation[validation], DATEPICKER_CLASSNAME_MAP.variant[variant], className),
      children: [/* @__PURE__ */jsx(InputComponent.Input, __spreadProps(__spreadValues({
        ref: inputRef
      }, rest), {
        type: "date",
        value,
        onClick: handleClick,
        onFocus: handleFocus,
        isLoading
      })), /* @__PURE__ */jsx(InputComponent.Icon, {
        className: "pd:datepicker__icon",
        children: /* @__PURE__ */jsxs(DropdownComponent.Button, {
          as: "button",
          ref: buttonRef,
          disabled,
          children: [/* @__PURE__ */jsx("span", {
            className: "pd:sr-only",
            children: datepickerScreenReaderLabel
          }), /* @__PURE__ */jsx(Icon_default, {
            icon: "calendar"
          })]
        })
      }), validation && !isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
        children: /* @__PURE__ */jsx(ValidationIcon_default, {
          variant: validation
        })
      }), isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
        children: /* @__PURE__ */jsx(Spinner_default, {
          variant: "primary"
        })
      })]
    }), /* @__PURE__ */jsx(DropdownComponent.Panel, {
      className: "pd:datepicker-dropdown__panel",
      children: /* @__PURE__ */jsx(DayPicker, __spreadProps(__spreadValues({}, datepickerConfig), {
        mode: "single",
        selected: dateValue,
        onSelect: handleSelectDate,
        defaultMonth
      }))
    })]
  });
});
var Datepicker_default = Datepicker;
export { DATEPICKER_CLASSNAME_MAP, Datepicker_default };